import React, { useState } from 'react'

import SvgRemove from '@chilipiper/icons/src/design-system/Remove'
import { Icon } from '../icon'
import { Button } from '../button'

type Props = {
  name?: string
  onRemove?: (evt: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

export const RemovePillButton = ({ onRemove, name }: Props) => {
  const [hovering, setHovering] = useState(false)

  return (
    <Button
      htmlType='button'
      title='Remove option'
      data-pill-remove={name}
      startIcon={
        <Icon icon={SvgRemove} pointer color={hovering ? 'icon/on-color' : 'icon/action-minor'} />
      }
      boxShadow='none'
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        onRemove?.(e)
      }}
      h={7}
      w={7}
      borderRadius='none'
      bg={hovering ? 'bg/action-bar-button-hovered-caution' : 'bg/list-item-unselected'}
    />
  )
}
